import { render, staticRenderFns } from "./ProductsWithSerial.vue?vue&type=template&id=9440f730&"
import script from "./ProductsWithSerial.ts?vue&type=script&lang=js&"
export * from "./ProductsWithSerial.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports